import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import axios from 'axios';

function Formulario(props) {
  const [loading, setLoading] = useState(true);
  const [pdfsEnabled, setPdfsEnabled] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const anexosValue = watch("anexos");

  useEffect(() => {
    if (anexosValue && anexosValue.value === "si") {
      setPdfsEnabled(true);
    } else {
      setPdfsEnabled(false);
      setSelectedFiles([]);
      setValue("pdfs", []);
    }
  }, [anexosValue, setValue]);

// Helper function to convert file to buffer
const convertFileToBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(Buffer.from(reader.result));
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
};

const onSubmit = async (data) => {
  try {
    // Verificar que todos los archivos sean PDF
    const validFiles = data.pdfs.filter(file => file.type === 'application/pdf');
    if (validFiles.length !== data.pdfs.length) {
      toast.error('Todos los archivos deben ser PDF.');
      return;
    }

    const listFiles = await Promise.all(validFiles.map(async (file) => {
      const buffer = await convertFileToBuffer(file);
      return buffer;
    }));

    let urls = [];
    for (const buffer of listFiles) {
      const param = {
        file: buffer
      };
      const result = await axios.post('https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/outsource/juridica/anexo', param);
      urls.push(result.data.data);
    }

    let body = {
      numero_factura_sap: data.invoice,
      anexos: data.anexos.label,
      files_anexos: urls.length < 0 ? '' : urls.toString(),
      observacion: data.description ? data.description : '',
      tipo: 'JURIDICA'
    };
    console.log(body);
    setLoading(true);
    const result = await axios.post('https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/outsource/juridica', body);
    setLoading(false);

    if (result.data.status) {
      toast.success(result.data.body.message);
      reset();
      setPdfsEnabled(false);
      setSelectedFiles([]);
      setValue('invoice', '');
      setValue('anexos', null);
      setValue('pdfs', []);
      setValue('description', '');
    } else {
      toast.error(result.data.body.message);
      setValue('invoice', '');
      setLoading(false);
    }
  } catch (error) {
    toast.error('Algo salió mal.');
    setValue('invoice', '');
    setLoading(false);
  }
};


  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
        <h1 className="formulario">Formulario envío facturas</h1>
        <Row className={"contenedorF-Filtrado mbottom-20"}>
          <Col xs={12} sm={6} md={4} lg={4} xl={4}>
            <Form.Group className="inputmayuscula">
              <Form.Label className="texto-label">Número de Factura</Form.Label>
              <Controller
                name="invoice"
                control={control}
                rules={{ required: "El campo es obligatorio" }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Control
                    type="number"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                    style={{ textAlign: 'center' }} // Centrar texto
                  />
                )}
              />
              {errors.invoice && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>

          <Col xs={12} sm={4} md={4} lg={4} xl={4}>
            <Form.Group controlId="formBasicEmail">
              <Form.Label className="texto-label">Anexos</Form.Label>
              <Controller
                name="anexos"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: "El campo es obligatorio",
                  },
                }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Select
                    onChange={(data) => {
                      onChange(data);
                    }}
                    value={value}
                    options={[{ label: "SI", value: "si" }, { label: "NO", value: "no" }]}
                  />
                )}
              />
              {errors.anexos && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>

          <Col xs={12} sm={4} md={4} lg={4} xl={4}>
            <Form.Group>
              <Form.Label className="texto-label">Cargar PDF</Form.Label>
              <Controller
                name="pdfs"
                control={control}
                rules={{ required: pdfsEnabled ? "El campo es obligatorio" : false }}
                render={({ field: { onChange, onBlur } }) => (
                  <Form.Control
                    type="file"
                    accept="application/pdf"
                    multiple
                    disabled={!pdfsEnabled}
                    onBlur={onBlur}
                    onChange={(e) => {
                      const files = Array.from(e.target.files);
                      setSelectedFiles(files);
                      onChange(files);
                    }}
                  />
                )}
              />
              {errors.pdfs && (
                <Form.Text id="passwordHelpBlock" className="error">
                  {errors.pdfs.message}
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className={"contenedorF-Filtrado mbottom-10"}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form.Group>
              <Form.Label className="texto-label">Comentarios</Form.Label>
              <Controller
                name="description"
                control={control}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Control
                    as="textarea"
                    rows={3}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                  />
                )}
              />
              {errors.description && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className={"mtop-10"}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Button
              type="submit"
              variant="primary"
              className="btn btn-primary boton"
              style={{ width: "100%" }}
            >
              Crear
            </Button>
          </Col>
        </Row>

        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
      </form>
    </>
  );
}

export default Formulario;